import {
  CustomButton,
  CustomInputSelect,
  CustomTextInput,
} from '@Modules/core/components';
import CustomFormControl from '@Modules/core/components/form/CustomFormControl';
import { IOwnerFormMeta } from '@Modules/terminalManagementSystem/merchant/containers/tableHandlers/merchantConsultation/merchantConsultationDetails/owner/OwnerMeta';
import { ChakraComponents as CC } from '@Modules/core/lib/chakra';
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import { FaSave } from 'react-icons/fa';
import displayCustomInputs from '@Shared/utils/displayCustomInputs';

type Props = {
  onSubmit: any,
  meta: IOwnerFormMeta,
  isLoading?: boolean,
  isSubmitting?: boolean,
};

const OwnerFormUI = ({ meta, onSubmit, isSubmitting, isLoading }: Props) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    // reset,
  } = useForm({ resolver: yupResolver(meta.schema) });

  return (
    <CC.Box w={'100%'} as={'form'} onSubmit={handleSubmit(onSubmit)}>
      
      <CC.SimpleGrid columns={{ base:1, md:2, lg:3 }} gridRowGap={4} columnGap={10} my={10}>
        {displayCustomInputs<IOwnerFormMeta>(
          meta,
          register,
          errors,
          isLoading
        )}
      </CC.SimpleGrid>

      <CC.HStack my={6} justifyContent={'flex-end'}>
        <CustomButton isLoading={isSubmitting} type={'submit'}>
          <FaSave style={{ marginRight: '10px' }} /> Enregistrer
        </CustomButton>
      </CC.HStack>
    </CC.Box>
  );
};

export default OwnerFormUI;
